/* global window */

const Join = (props) => {
  const { onClickGTM, club, deliveryMethod } = props;
  let url = `/club/${club.slug}`;
  if (deliveryMethod && deliveryMethod === 'Pickup') {
    url += `?deliveryMethod=${deliveryMethod}`;
  }
  const handleLink = (e) => {
    e.preventDefault();
    onClickGTM(club);
    window.location.href = url;
  };
  return (
    <a href="" onClick={handleLink} className="c7-button">
      Join Now
    </a>
  );
};

export default Join;
